import { BlockProductsType } from '../../models/Content';
import { selectProductsQueryKey } from '../../utils/contentSelectors';
import { transformCta } from '../../utils/transformers';
import { BlockProductsData } from './model';

export const transformBlockProducts = (blockProducts: BlockProductsType): BlockProductsData => {
    if (!blockProducts) {
        return undefined;
    }

    return {
        id: blockProducts.sys.id,
        blockTitle: blockProducts.fields.title,
        blockCta: transformCta(blockProducts.fields.cta),
        queryKey: selectProductsQueryKey(blockProducts),
    };
};
